module.exports = __webpack_public_path__ + "media/images/favicon_godibesuchen-7922fee632f64b469a1fa8ebf7207238.png";